import { useState } from "react";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { IListPDF } from "src/Pages/components/DropZoneCore/DropZoneCore";
import { api } from "src/shared/setup/API/api";

interface IUseFormComprovante {
  id: string;
}

interface IUseFormComprovante2 {
  uploadComprovanteFiles: IListPDF[];
  type: "COMPROVANTE_PAGAMENTO" | "NOTA_FISCAL";
}

export const UseFormComprovante = ({ id }: IUseFormComprovante) => {
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const handleCreate = async ({
    uploadComprovanteFiles,
    type,
  }: IUseFormComprovante2) => {
    setLoading(true);

    const formData = new FormData();

    uploadComprovanteFiles.forEach((file) => {
      const blob = new Blob([file.pdf], { type: file.type });
      formData.append("files", blob, file.name);
      formData.append("type", type);
    });

    return api
      .post(`/comprovantes-pagamentos/${id}`, formData)
      .then((res) => {
        handleGetAlert({ message: res.data.message });
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return { handleSubmit: handleCreate, loading };
};
